import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../../../core';
import { Alert, Loader } from '../../../../components';
import * as Forms from '../../../../components/forms';
import Translate from '../../../../core/translate';
import API from '../../../../services/api';
import { IResponse } from '../../../../services/model';
import Common, { FormService } from '../../../../services/common';
import { IPasajero } from '../../../../services/api/entity/model/IPasajero';
import { IPais } from '../../../../services/api/entity/model';

interface IProps {
  storage?: IDataStorage;
  refService?: (form:FormService<IPasajero>) => void;

  id?: number;
  readonly?: boolean;
}

interface IState {
  storage?: IDataStorage;

  id?: number;
  readonly?: boolean;

  entity?: IPasajero;

  paises?: IPais[];
}

class Index extends React.Component<IProps, IState> {
  form : FormService<IPasajero>;
  constructor(props:IProps) {
    super(props);
    this.form = Common.form(() => this.getEntity);
  }

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadEntities(this.state.id);
    this.props.refService && this.props.refService(this.form);
  }

  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.id !== s?.id) res.id = p.id;
    if (p?.readonly !== s?.readonly) res.readonly = p.readonly;
    return res;
  }

  private loadEntities = (id?: number) => {
    const t = Translate.get("config/pasajero/form", this.state.storage?.languaje);
    if (id) {
      API.OperacionesController().Pasajero().getEdit({ id }).then(res => {
        if (!res.success) return Alert.reponse(res);
        const ent = res.data ?? {};
        ent.nacimiento = !!ent.nacimiento ? new Date(ent.nacimiento) : undefined;
        this.setState({ entity: this.form.setEntity(res.data) });
      }).catch(ex => Alert.exception(t, ex));
    };
      
    API.entity().pais().all().then(res => {
      Alert.reponse(res);
      this.setState({ paises: (res.data ?? []).sort((a,b) => (a?.nombre ?? '') > (b?.nombre ?? '') ? 1 : -1) });
    });
  }

  private change = (field: string, value: any, error?: string) => {
    this.setState({ entity: this.form.setValue(field, value, error) });
  }

  render() {
    const { readonly, entity } = this.state;
    const t = Translate.get("config/pasajero/form", this.state.storage?.languaje);

    return (
      <Loader loading={!entity}>
        <Forms.Input form={this.form} name='nombre' title={t("Col.nombre")} required placeholder={t("Col.nombre.Placeholder")} disabled={readonly} value={entity?.nombre} onChange={(v, e) => this.change('nombre', v, e)} />
        <Forms.Input form={this.form} name='apellido' title={t("Col.apellido")} placeholder={t("Col.apellido.Placeholder")} disabled={readonly} value={entity?.apellido} onChange={(v, e) => this.change('apellido', v, e)} />
        <Forms.Calendar form={this.form} name='nacimiento' disabled title={t("Col.fechanacimiento")} placeholder={t("Col.fechanacimiento.Placeholder")} value={entity?.nacimiento ? new Date(entity?.nacimiento) : undefined} onChange={(v, e) => this.change('fechanacimiento', v, e)} />
        <Forms.Input form={this.form} name='documento' title={t("Col.documento")} placeholder={t("Col.documento.Placeholder")} disabled={readonly} value={entity?.documento} onChange={(v, e) => this.change('documento', v, e)} />
      </Loader>
    );
  }
  
  /** devuelve la entidad */
  getEntity = () : IResponse<IPasajero> => {
    var isValid = this.form.isFormValid();
    if (!isValid) {
      return { success: false, error: (this.form.getStatus().errors ?? [])[0] };
    } else {
      const data = this.form.form.getEntity();
      if (!data.id) data.id = data.persona?.id;
      return { success: true, data };
    }
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
